import React, { useCallback } from 'react'
import { useNewTranslation } from 'hooks/index'
import { useDispatch, useSelector } from 'react-redux'

import {
    MAX_PAGE_SIZE,
    selectActivePageNum,
    selectIsMultiSelectMode,
    selectSelectedCampaignUuid,
    selectShowReviewButtons,
    selectSidebarStep,
    selectSubmissionListParams,
    SubmissionProgressProps,
} from 'state/review'
import { reviewPendingAction } from 'state/submissions'
import { SubmissionActionWrapper } from './styles'
import RectangleButton from 'particles/Button/RectangleButton'

interface ReviewButtonsProps {
    submissionProgress: SubmissionProgressProps
}

const ReviewButtons: React.FC<ReviewButtonsProps> = ({ submissionProgress }) => {
    const [newT] = useNewTranslation()
    const dispatch = useDispatch()
    const isMultiSelectMode = useSelector(selectIsMultiSelectMode)
    const selectedCampaignUuid = useSelector(selectSelectedCampaignUuid)
    const showReviewButtons = useSelector(selectShowReviewButtons)
    const activePageNum = useSelector(selectActivePageNum)
    const selectedStep = useSelector(selectSidebarStep)
    const submissionListParams = useSelector(selectSubmissionListParams)

    const getSubmissionListPayload = {
        offset: activePageNum * MAX_PAGE_SIZE,
        stepUuid: selectedStep?.uuid,
        ...submissionListParams,
    }

    const handleApprovePendingAction = useCallback(() => {
        if (selectedCampaignUuid) {
            dispatch(
                reviewPendingAction({
                    campaignUuid: selectedCampaignUuid,
                    submissionUuid: submissionProgress.uuid,
                    actionType: 'approve',
                    getSubmissionListPayload,
                }),
            )
        }
    }, [selectedCampaignUuid, submissionProgress])
    const handleRejectPendingAction = useCallback(() => {
        if (selectedCampaignUuid) {
            dispatch(
                reviewPendingAction({
                    campaignUuid: selectedCampaignUuid,
                    submissionUuid: submissionProgress.uuid,
                    actionType: 'reject',
                    getSubmissionListPayload,
                }),
            )
        }
    }, [selectedCampaignUuid, submissionProgress])

    return showReviewButtons ? (
        <SubmissionActionWrapper>
            <RectangleButton
                form="filled"
                size="m"
                label={newT('button.acceptStatus', 'Accept Status')}
                onClick={handleApprovePendingAction}
                isDisabled={isMultiSelectMode}
                className="width-full"
            />
            <RectangleButton
                form="outlined"
                size="m"
                color="neutral"
                label={newT('button.moveBackToPending')}
                onClick={handleRejectPendingAction}
                isDisabled={isMultiSelectMode}
                className="width-full"
            />
        </SubmissionActionWrapper>
    ) : null
}

export default ReviewButtons
